import Grid from '@material-ui/core/Grid';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';
import PlaceListItem from './PlaceListItem';
import React, { memo, VFC } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { NearbyPlaceProps, NearbyPlacesProps } from '../types';

const useStyles = makeStyles((theme) => ({
  description: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
  },
  remarks: {
    fontSize: theme.typography.pxToRem(14),
    marginTop: theme.spacing(1),
  },
}));

const NearbyPlacesComponent: VFC<NearbyPlacesProps> = memo(
  ({
    nearbyPlace,
    nearbyPlaces = [],
    isNearbyPlaceUnavailable = false,
  }: NearbyPlacesProps) => {
    const classes = useStyles();

    // 各項目や「あてはまるものはない」を選択していない（既存の募集）では表示しない
    const isShown =
      isNearbyPlaceUnavailable ||
      nearbyPlaces.some(({ isAvailable }) => isAvailable);
    if (!isShown) return null;

    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography className={classes.description}>
            {T.translate('planPage.nearbyPlaces.description')}
          </Typography>
        </Grid>
        {nearbyPlaces.map((nearbyPlace: NearbyPlaceProps) => (
          <PlaceListItem
            key={nearbyPlace.kind}
            {...nearbyPlace}
            {...{ isNearbyPlaceUnavailable }}
          />
        ))}
        {nearbyPlace && (
          <Grid item xs={12}>
            <Typography classes={{ root: classes.remarks }}>
              {nearbyPlace}
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  },
);

export default NearbyPlacesComponent;
